export default {
    formatPhone: (number) => {
        let phoneFormat = null;
        try {
            if (number) {
                if (number.indexOf('-') > -1) {
                    phoneFormat = number.split('-');
                    phoneFormat = `(${phoneFormat[0]}) ${phoneFormat[1]}-${phoneFormat[2]}`;
                } else {
                    phoneFormat = number.match(/^(\d{3})(\d{3})(\d{4})$/);
                    phoneFormat = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
                }
                
            } else {
                phoneFormat = number;
            }
            return phoneFormat;
        } catch (e) {
            return number;
        }
    }
}        